module.exports = __webpack_public_path__ + "static/media/word_party.f85ed2d8.png";